import styled from "styled-components";
import { colors } from "globalStyles";

export const Wrapper = styled.div`
  padding: 24px 0;
  max-width: 720px;

  h1 {
    font-size: 24px;
    font-weight: bold;
    color: ${colors.DARK_GRAY};
    margin-bottom: 16px;
  }

  .admin-settings__error {
    font-size: 14px;
    font-weight: normal;
    color: ${colors.MEDIUM_GRAY};
    padding: 24px 0;
  }

  .admin-settings__note {
    font-size: 12px;
    font-weight: normal;
    color: ${colors.MEDIUM_GRAY};
    margin-bottom: 8px;
  }
`;

export const DetailLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.MEDIUM_GRAY};
  margin-bottom: 8px;
`;

export const TermsTextarea = styled.textarea`
  width: 100%;
  min-height: 320px;
  padding: 12px;
  border: 1px solid ${colors.LIGHT_GRAY};
  border-radius: 6px;
  font-family: monospace;
  font-size: 13px;
  line-height: 1.5;
  color: ${colors.DARK_GRAY};
  background: ${colors.WHITE};
  resize: vertical;
`;

export const SaveButton = styled.button`
  margin-top: 16px;
  height: 38px;
  padding: 0 16px;
  border: 1px solid ${colors.SILKBLUE};
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  color: ${colors.WHITE};
  background: ${colors.SILKBLUE};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FormError = styled.div`
  padding: 10px 12px;
  margin-bottom: 16px;
  border-radius: 6px;
  font-size: 13px;
  color: ${colors.DANGER_FG};
  background: ${colors.DANGER_BG};
`;
